import React from 'react';
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

// import {deleteThisBusiness} from "../../../../../services/Business/BusinessService";
import IModalBody from "../../../../../components/Admin/Modal/IModalBody";
import IModal from "../../../../../components/Admin/Modal/IModal";
import {deleteEventApi} from "../../../../../api/AdminApi";
import {successMessage} from "../../../../../tools/messages";


const DeleteItem = ({open, close, itemId, invalidateData = undefined}) => {
    const deleteById = async () => {
        try {
            const res = await deleteEventApi({event_id: itemId});
            successMessage(res.data.msg)
            await invalidateData();

        } catch (e) {
        }
        close();
    }

    return (
        <>
            <IModal width={300} showClose open={open} handleClose={close}>

                <IModalBody>
                    <Grid container display={'flex'} direction={'column'}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color={"error"}>
                            حذف ایونت
                        </Typography>
                        <Typography id="spring-modal-description" sx={{mt: 2, pl: 5, pr: 5}}>
                            آیا میخواهید این ایونت را حذف کنید؟</Typography>
                        <Grid item display={'flex'} justifyContent={'space-evenly'} sx={{marginTop: '20px'}}>
                            <Button variant="contained" color={'error'} onClick={close} sx={{
                                background: 'linear-gradient(273.72deg, #4CB269 5.88%, #80B83F 128.9%)',
                                borderRadius: '30px',
                                padding: '0.5rem 3rem',
                                fontSize: '18px',
                            }}>خیر</Button>
                            <Button onClick={deleteById} color={'error'} variant="contained" sx={{
                                // background: 'linear-gradient(273.72deg, #4CB269 5.88%, #80B83F 128.9%)',
                                padding: '0.5rem 3rem',
                                borderRadius: '30px',
                                fontSize: '18px'
                            }}>بله</Button>
                        </Grid>
                    </Grid>
                </IModalBody>
            </IModal>
        </>
    );
};

export default DeleteItem;